export default __webpack_public_path__ + "static/media/screen3.50df6834.png";